import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=cc5a5b1a&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5a5b1a')) {
      api.createRecord('cc5a5b1a', component.options)
    } else {
      api.reload('cc5a5b1a', component.options)
    }
    module.hot.accept("./complete.vue?vue&type=template&id=cc5a5b1a&lang=pug&", function () {
      api.rerender('cc5a5b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/password_reset/complete.vue"
export default component.exports